// import React from 'react';
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router';
import { FaEye, FaEdit, FaTrash } from 'react-icons/fa';
import { useDispatch, useSelector } from "react-redux";
import { openModal } from "../../redux/features/modalSlice";
import { setCity } from '../../redux/features/filtersSlice';
import SearchBar from "../../common/Search";
import Pagination from "../../common/Pagination";
import { FaMapMarkerAlt, FaPlus } from "react-icons/fa";
import CommonBreadcrumb from '../../common/CommonBreadcrumb';
// import { useGetCityQuery, useDeleteCityMutation } from "../../redux/services/cityService/city.Services";
import { useGetDistrictQuery } from "../../redux/services/districtService/district.Services";
import { successToast, errorToast } from "../../Utils/toast";
function District() {
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const filter = useSelector((state) => state.filters.city)
    const { data, isLoading, isError } = useGetDistrictQuery(filter);
    //  const [deleteCity] = useDeleteCategoryMutation();
    const cityData = data?.data || [];
    const pagination = data?.pagination || {};
    const totalPages = pagination?.totalPages || 0;
    const showPagination = totalPages > 1;
    const hasData = setCity?.length > 0;
    const handlePageChange = (page) => {
        dispatch(
            setCity({
                page,
            })
        );
    };
    const handleSearch = (value) => {
        dispatch(
            setCity({
                search: value,
                page: 1,
            })
        );
    }

    if (isLoading) {
        return <h3>Loading...</h3>;
    }
    if (isError) {
        return <h3>Something Went Wrong</h3>;
    }
    return (
        <div>
            {/* <div className="page-header-breadcrumb all_breadcrumb">
                <div className="ms-md-1 mb-1 mb-md-0 ms-0 page_heading_breadcrumb">
                    <nav>
                        <h4 className="fw-semibold">
                            All District
                        </h4>

                        <ol className="breadcrumb mb-0">

                            <li className="breadcrumb-item">

                                <Link to="/">
                                    Home
                                </Link>

                            </li>

                            <li
                                className="breadcrumb-item active"
                                aria-current="page"
                            >
                                All District
                            </li>

                        </ol>

                    </nav>

                </div>

                <div className="page-title fw-semibold fs-18 mb-0">

                    <button

                        onClick={() => navigate("/add-district")}
                        className="btn btn-primary"
                    >
                        Add District
                    </button>

                </div>


            </div> */}
            <CommonBreadcrumb
    title="All District"
    titleIcon={<FaMapMarkerAlt className="me-2 text-primary" />}
    breadcrumbs={[
        { label: "Home", link: "/" },
        { label: "All District" },
    ]}
    buttons={[
        {
            text: "Add District",
            icon: <FaPlus className="me-1" />,
            link: "/add-district",
            className: "btn btn-primary",
        },
    ]}
/>
            {/* TABLE */}
            <div className="st-wrapper-card">
                <div className="searchbox">
                    <SearchBar
                        search={filter.search}
                        setSearch={handleSearch}
                        placeholder="Search  Categories..."
                    />

                </div>

                <div className="st-table-responsive">

                    <table className="table st-custom-table align-middle mb-0">

                        <thead>

                            <tr>

                                <th>Sr.No</th>

                                <th>City Name</th>

                                <th>State Name</th>
                                <th>Status</th>
                                <th> Change Status</th>

                                <th className="text-center">
                                    Action
                                </th>

                            </tr>

                        </thead>

                        <tbody>

                            {
                                cityData.map((item, index) => (

                                    <tr key={item.id}>

                                        {/* ID */}
                                        <td>
                                            {index + 1}
                                        </td>

                                        {/* CITY NAME */}
                                        <td className="fw-semibold">
                                            {item.name}
                                        </td>
                                        <td>
                                            {item?.state_name}
                                        </td>
                                        <td className="fw-semibold">{item.status === "active" ? "Active" : "Inactive"}</td>
                                        {/* STATUS */}
                                        <td style={{ width: "150px" }}>

                                            <div className="city-status-switch">

                                                <input
                                                    type="checkbox"
                                                    id={`status-${item.id}`}
                                                    className="city-status-input"
                                                    checked={item.status === "active"}

                                                    onChange={() =>
                                                        dispatch(
                                                            openModal({
                                                                type: "status-city",
                                                                title: "Change City Status",
                                                                // data: {
                                                                //     id: item.id,
                                                                //     name: item.name,
                                                                //     status: item.status,
                                                                //     apiUrl: "city-status",
                                                                // },
                                                                data: {
                                                                    id: item.id,
                                                                    name: item.name,
                                                                    status: item.status,
                                                                    apiUrl: "/city-status",
                                                                    message: `You want to change status of ${item.name}`
                                                                }
                                                            })
                                                        )
                                                    }
                                                />

                                                <label
                                                    htmlFor={`status-${item.id}`}
                                                    className="city-status-label"
                                                >

                                                    <span className="city-status-ball"></span>

                                                    <span className="city-status-text">

                                                        {
                                                            item.status
                                                                ? "Active"
                                                                : "Inactive"
                                                        }

                                                    </span>

                                                </label>

                                            </div>

                                        </td>

                                        {/* ACTION */}
                                        <td className="text-center">

                                            {/* VIEW */}
                                            <button
                                                className="st-action-btn st-view-btn"
                                                onClick={() =>
                                                    dispatch(
                                                        openModal({
                                                            type: "view-city",
                                                            title: "City Details",
                                                            data: item,
                                                        })
                                                    )
                                                }
                                            >
                                                <FaEye />
                                            </button>

                                            {/* EDIT */}
                                            <button
                                                className="st-action-btn st-edit-btn"
                                                onClick={() =>
                                                    dispatch(
                                                        openModal({
                                                            type: "edit-city",
                                                            title: "Edit City",
                                                            data: item,
                                                        })
                                                    )
                                                }
                                            >
                                                <FaEdit />
                                            </button>

                                            {/* DELETE */}
                                            <button
                                                className="st-action-btn st-delete-btn"
                                                onClick={() =>
                                                    dispatch(openModal({
                                                        type: "delete-city",
                                                        title: "Delete City",
                                                        // data: {
                                                        //     ...item,
                                                        //     deleteFunction: deleteCity,
                                                        // }
                                                        data: {
                                                            id: item.id,
                                                            apiUrl: "/city-delete",
                                                            message: `You are deleting ${item.name}`,
                                                        }
                                                    }))
                                                }
                                            >
                                                <FaTrash />
                                            </button>




                                        </td>

                                    </tr>

                                ))
                            }

                        </tbody>

                    </table>
                    <div className="d-flex justify-content-end mt-4">

                        {showPagination && (
                            <div className="d-flex justify-content-end mt-4">
                                <Pagination
                                    page={filter.page}
                                    totalPages={totalPages}
                                    onPageChange={handlePageChange}
                                />
                            </div>
                        )}

                    </div>
                </div>

            </div>

        </div>
    );
}

export default District;